/**
 * App Routes (User-facing)
 *
 * Purpose: Routes for authenticated users
 * Protected by AuthGuard
 */

import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AuthGuard } from '@/features/common/guards/AuthGuard'
import { AppLayout } from '@/layouts/AppLayout'
import { LoadingSpinner } from '@/features/common/components/LoadingSpinner'

// Lazy load pages for code splitting
const HomePage = lazy(() =>
  import('@/features/app/pages/HomePage').then(m => ({ default: m.HomePage }))
)
const ProfilePage = lazy(() =>
  import('@/features/app/pages/ProfilePage').then(m => ({ default: m.ProfilePage }))
)

// Loading fallback for lazy-loaded app pages
function AppPageLoader() {
  return (
    <div className="flex items-center justify-center h-64">
      <LoadingSpinner size="lg" />
    </div>
  )
}

export function AppRoutes() {
  return (
    <Suspense fallback={<AppPageLoader />}>
      <Routes>
        <Route
          element={
            <AuthGuard>
              <AppLayout />
            </AuthGuard>
          }
        >
          <Route index element={<HomePage />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
